function Support() {
    return <h2>Support Page</h2>
}

export default Support
